import React from "react";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { BreadcrumbItemProps } from "../types";

function BreadcrumbItem({ className = "", ...props }: BreadcrumbItemProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <li
      data-slot="breadcrumb-item"
      className={cn("inline-flex items-center gap-1.5", className, classes)}
      {...native}
    />
  );
}

BreadcrumbItem.displayName = "Breadcrumb.Item";

export default BreadcrumbItem;
